import Step from 'aa/vue/models/steps/Step'
import AgeGateComponent from 'aa/vue/components/AgeGate'

export default class AgeAgate extends Step {
    path = '/signup/age-gate/'
    name = 'AGE_GATE'
    component = AgeGateComponent
    requireAuth = false
    requireNonAuth = true
    countStep = false
    hideSignInLink = true
    hideSignUpLink = true

    async beforeEnter(to, from, next) {
        if (!from || from.name === null) {
            window.location.href = '/'
            return
        }
        return super.beforeEnter(to, from, next)
    }
    /**
     * @param to
     * @returns {{path: *, name: *}}
     */
    getTrackingArgs(to) {
        let args = super.getTrackingArgs(to);

        args.pageTitle = '';
        args.pageType = 'svod_invalid-birthdate'
        return args;
    }

}
